// Central mutable app state + tiny event bus (pattern from epidemic-monitor's AppContext).
type EventName = "province-change";
type Listener = () => void;

class AppContext {
  selectedProvince: string | null = null;
  private listeners = new Map<EventName, Set<Listener>>();

  on(event: EventName, fn: Listener): void {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event)?.add(fn);
  }

  off(event: EventName, fn: Listener): void {
    this.listeners.get(event)?.delete(fn);
  }

  private emit(event: EventName): void {
    for (const fn of this.listeners.get(event) ?? []) fn();
  }

  setProvince(code: string | null): void {
    if (this.selectedProvince === code) return;
    this.selectedProvince = code;
    this.emit("province-change");
  }
}

export const appContext = new AppContext();
